import Banner from "../components/Banner";
import TopRestaurants from "../components/TopRestaurants";

const Home = () => {
  return (
    <div>
      <Banner />
      <TopRestaurants />
    </div>
  );
};

export default Home;
